import { render, staticRenderFns } from "./CandidateAcceptActivator.vue?vue&type=template&id=c7803d30&lang=pug&"
import script from "./CandidateAcceptActivator.vue?vue&type=script&lang=js&"
export * from "./CandidateAcceptActivator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
